import { combineReducers } from '@reduxjs/toolkit'
import {
  consolidatedPortfolioDownloadReducer,
  consolidatedPortfolioReducer,
  globalPositionDownloadReducer,
  globalPositionReducer,
  positionCreditsFiltersReducers,
  positionDepositsFiltersReducers,
  positionInvestmentsFiltersReducers,
} from '../slices'

export const positionReducers = combineReducers({
  master: combineReducers({
    list: combineReducers({
      consolidatedPortfolio: consolidatedPortfolioReducer,
      consolidatedPortfolioDownload: consolidatedPortfolioDownloadReducer,
      globalPosition: globalPositionReducer,
      globalPositionDownload: globalPositionDownloadReducer,
    }),
    filters: combineReducers({
      investments: positionInvestmentsFiltersReducers,
      credits: positionCreditsFiltersReducers,
      deposits: positionDepositsFiltersReducers,
    }),
  }),
})
